"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPublicKey = function (val) {
    return val.publicKey !== undefined;
};
exports.isPrivateKey = function (val) {
    return val.privateKey !== undefined;
};
// export type Words = CryptoJS.LibWordArray | CryptoJS.WordArray | CryptoJS.DecryptedMessage
//
// export const isWords = (val: any): val is Words =>
//   (<CryptoJS.LibWordArray>val).words !== undefined ||
//   (<CryptoJS.WordArray>val).key !== undefined
//# sourceMappingURL=util.js.map